import React from "react";
import { BrandCard } from "../integrations/brand";
import { useTranslation } from "../../hooks/useTranslation";

/**
 * Un consumo del piano, come i numeri di Analisi: quanto usi, su quanto
 * comprende il piano (0 = illimitato), la barra e cosa vuol dire.
 * Rosso solo oltre il limite: arrivarci (1 assistente su 1) e' normale.
 * `ripartono`: per le risposte del mese, quando il contatore torna a zero.
 */
export default function Consumo({ etichetta, usato = 0, limite, ripartono }) {
  const { t, i18n } = useTranslation();
  const numero = (n) => Number(n || 0).toLocaleString(i18n.language);
  const illimitato = !limite;
  const oltre = !illimitato && usato > limite;
  const pieno = !illimitato && usato >= limite;
  const quota = illimitato ? 0 : Math.min(100, Math.round((usato / limite) * 100));
  const colore = oltre ? "bg-red-500" : quota >= 80 ? "bg-amber-500" : "bg-[#18181B]";
  const nota = illimitato
    ? t("usage.noLimit")
    : oltre
      ? t("usage.overLimit", { count: usato - limite, value: numero(usato - limite) })
      : pieno
        ? t("usage.limitReached")
        : t("usage.remaining", { count: limite - usato, value: numero(limite - usato) });
  return (
    <BrandCard className="p-5">
      <p className="text-xs font-medium text-[#64748B]">{etichetta}</p>
      <p className="mt-2 flex flex-wrap items-baseline gap-x-1.5 tabular-nums">
        <span className="text-2xl font-semibold tracking-tight text-[#020617]">{numero(usato)}</span>
        {illimitato ? null : <span className="text-sm text-[#94A3B8]">{t("usage.ofMax", { max: numero(limite) })}</span>}
      </p>
      <div className="mt-4 h-1 overflow-hidden rounded-full bg-[#F1F5F9]" aria-hidden="true">
        <div className={`h-full rounded-full ${colore}`} style={{ width: `${illimitato ? 0 : Math.max(quota, usato ? 2 : 0)}%` }} />
      </div>
      <p className={`mt-2 text-xs ${oltre ? "font-medium text-red-600" : "text-[#64748B]"}`}>{nota}</p>
      {ripartono && !illimitato ? (
        <p className="mt-0.5 text-xs text-[#94A3B8]">
          {t("usage.restartsOn", {
            date: new Intl.DateTimeFormat(i18n.language, { day: "numeric", month: "long" }).format(new Date(ripartono)),
          })}
        </p>
      ) : null}
    </BrandCard>
  );
}
